import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SputnikAPIResponseState {
  [tag: string]: {
    data: any
    expanded: any
  }; // Prefer a more specific type if known
}

const initialState: SputnikAPIResponseState = {};

const sputnikapiresponseSlice = createSlice({
  name: 'sputnikapiresponse',
  initialState,
  reducers: {
    setSputnikAPIResponseData: (state, action: PayloadAction<{ tag: string, data: any }>) => {
      // console.log('setting',action.payload.tag,'to',action.payload.data)
      if (!state[action.payload.tag]) {
        state[action.payload.tag]={data:{},expanded:{}}
      }
      state[action.payload.tag].data = action.payload.data;
    },
    setSputnikAPIKeyExpandedData: (state, action: PayloadAction<{ tag: string, key: string, data: any }>) => {
      // console.log(action)
      if (!state[action.payload.tag]) {
        state[action.payload.tag]={data:{},expanded:{}}
      }      
      state[action.payload.tag].expanded[action.payload.key] = action.payload.data;
    },
    resetSputnikAPIResponseData: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    }
  }
});

export const { setSputnikAPIResponseData, resetSputnikAPIResponseData, setSputnikAPIKeyExpandedData } = sputnikapiresponseSlice.actions;

export const selectSputnikAPIResponseDataByTag = (state: { sputnikapiresponse: SputnikAPIResponseState }, tag: string) => state.sputnikapiresponse[tag]?.data;
export const selectSputnikAPIResponseExpandedByTag = (state: { sputnikapiresponse: SputnikAPIResponseState }, tag: string,key:string) => state.sputnikapiresponse[tag]?.expanded[key];

export default sputnikapiresponseSlice.reducer;
